import React, {useEffect} from 'react';
import './App.css';
import AirQualityContainer from "./container/AirQualityContainer";

function App() {

    useEffect(() => {
        document.body.style.backgroundColor = process.env.REACT_APP_BACKGROUND_COLOR ? process.env.REACT_APP_BACKGROUND_COLOR : '#fffff';
    }, []);


    return (
        <div className="App">
            <header className="App-header" />
            <AirQualityContainer/>
        </div>
    );
}

export default App;
